import { User } from '../models/user.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable()
export class UserService {
  constructor(private readonly http: HttpClient) {}

  getAllUsers(): Observable<{ count: number, data: User[] }> {
    return this.http.get<{ count: number, data: User[] }>(`${environment.apiUrl}/users?role=user`);
  }

  createUser(payload: User): Observable<User> {
    return this.http.post<User>(`${environment.apiUrl}/users`, {
      ...payload,
      phoneNumber: payload.phoneNumber.replace(/ /g,'')
    });
  }

  deleteUsers(payload: { ids: number[] }): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        ids: payload.ids
      },
    };

    return this.http.delete<any>(`${environment.apiUrl}/users`, options);
  }
}
